import { render, staticRenderFns } from "./ProfileAlertRaised.vue?vue&type=template&id=a3006ae4&scoped=true&"
import script from "./ProfileAlertRaised.vue?vue&type=script&lang=js&"
export * from "./ProfileAlertRaised.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAlertRaised.vue?vue&type=style&index=0&id=a3006ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3006ae4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a3006ae4', component.options)
    } else {
      api.reload('a3006ae4', component.options)
    }
    module.hot.accept("./ProfileAlertRaised.vue?vue&type=template&id=a3006ae4&scoped=true&", function () {
      api.rerender('a3006ae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/alert_raised/ProfileAlertRaised.vue"
export default component.exports